import {Component, h} from 'preact';

/*
* <LazyComponent 
*   getComponent={import('./exapmle')}    // Callback for loading the component
*   showLoader={true}                     // Show loader while the component is loading
*   scroll={true}                         // Start loading only when the component is about to come into view
*   onLoad={()=>console.log('done')}      // Callback for when the component is loaded
*   expectedHeight={200}                  // Expected height of the loaded component, used for min-height of the loader. 
* />
*
*/

export default class LazyComponent extends Component {
	componentDidMount() {
		this.state.component=undefined;
		this.loading=false;
		if (this.props.scroll && window) {
			window.addEventListener('scroll',this.handleScroll)
      if (document.readyState === 'complete') {
        this.handleScroll();
      } else {
        window.addEventListener('load',this.handleScroll)
      }
		} else {
      this.loadComponent();
    }
	}

  loadComponent() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.loadComponentNow);
    } else {
      this.loadComponentNow();
    }
  }

  loadComponentNow = () => {
    if (!this.loading) {
      this.loading=true;
      this.props.getComponent().then((module)=>{
        this.setState({component:module.default})
        if (this.props.onLoad && typeof this.props.onLoad == 'function'){ this.props.onLoad()}
        if (this.props.scroll) window.removeEventListener('scroll', this.handleScroll);
      });
    }
  }

	handleScroll = () => {
    let { ref } = this
    if (ref) {
      let bufferArea = window.innerHeight*0.3,
          scrollY = window.scrollY>bufferArea ? window.scrollY - bufferArea : 0,
          scrollYbottom = window.scrollY + window.innerHeight + bufferArea,
          offsetTop = ref.offsetTop,
          offsetBottom = offsetTop+(ref.clientHeight ? this.ref.clientHeight : 200);
      if (scrollY < offsetBottom && scrollYbottom > offsetTop) {
        this.loadComponent();
      }
    }
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('load', this.handleScroll);    
	}

	render(props) {
    return this.state.component ?
              h(this.state.component,props) :
                <div style={"min-height:"+(props.expectedHeight ? props.expectedHeight : 200 )+"px;position: relative;"} {...props} ref={ref=>this.ref=ref}>
                  {props.showLoader && <div class="preloader-small loading"/>}
                </div>;
  }
}



// WEBPACK FOOTER //
// ./components/asyncComponent.js